import * as React from 'react';
import styles from './MainInfo.module.sass';

export interface IProps {
	children?: any;
	title: string;
	value: string;
}

export default function MainInfo(props: IProps) {
	return (
		<div className={styles.mainInfo}>
			<div className={styles.title}>{props.title}</div>
			<div className={styles.hash}>{props.value}</div>
			<div>{props.children}</div>
		</div>
	);
}
